<template>
	<div>
		<v-dialog v-model="sectionListDialog" no-click-animation persistent scrollable content-class="full-height select_field_dialog" lazy transition="dialog-bottom-transition">
	        <v-card>
	        	<v-card-title noshadow class="dialog_searchbox">
	        		<v-subheader full-width>Select Section
		        		<v-spacer></v-spacer>
		        		<v-btn color="primary" icon @click="fn_openSectionForm">
		        			<v-icon>add</v-icon>
		        		</v-btn>
	        		</v-subheader>

	        		<v-text-field  solo flat placeholder="Search" v-model="searchValue"></v-text-field>
	        	</v-card-title>
	        	<!-- <v-divider></v-divider> -->
		        <v-card-text full-height nopadding :class="{'no-items-list-card': !filteredItems.length}">
		        	<!-- <v-radio-group v-model="selectedSection" right-align-radio>
			            <v-radio :label="item.section.sectionName" :value="item.section.sectionName" v-for="(item, index) in filteredItems" :key="index" @change="updateSection(item.section)">
			            </v-radio>
			        </v-radio-group> -->

			        <v-list nopadding>
			        	<v-list-tile v-for="(item, index) in filteredItems" :key="index" @click="updateSection(item.section)">
			        		

				            <v-list-tile-content>
				              <v-list-tile-title>{{item.section.sectionName}}</v-list-tile-title>
				            </v-list-tile-content>

				            <v-list-tile-action>
				              	<!-- <v-radio-group v-model="selectedSection">
						            <v-radio :value="item.section.sectionName" @change="updateSection(item.section)"></v-radio>
						        </v-radio-group> -->
						        <!-- <input type="radio" :value="item.section.sectionName" v-model="selectedSection" @change="updateSection(item.section)" v-show="false"> -->
						        <v-icon v-if="item.section.sectionName == selectedSection">radio_button_checked</v-icon>
						        <v-icon v-else>radio_button_unchecked</v-icon>
				            </v-list-tile-action>
			        	</v-list-tile>
			        </v-list>

			        <div class="display_msg" v-if="!filteredItems.length">No Items</div>
		        </v-card-text>

		       <!--  <div v-for="(item, index) in filteredItems" :key="index">
		        	<input type="radio" :value="item.section.sectionName" v-model="selectedSection" @change="updateSection(item.section)">
					<label>{{item.section.sectionName}}</label>
		        </div> -->
		        <v-divider></v-divider>
		        <v-card-actions>
		        	<v-spacer></v-spacer>
          			<v-btn small color="blue darken-1" flat @click="$parent.fn_closeDialog">close</v-btn>
		          	<!-- <v-btn small color="blue darken-1" flat @click="$parent.fn_closeDialog">ok</v-btn> -->
		        </v-card-actions>
		    </v-card>


	    </v-dialog>
	</div>
</template>

<script>
	export default{
		props:['updateSection', 'openSectionForm', 'getFieldData'],
		data(){
			return{
				selectedSection: null,
				sectionListDialog:false,
				searchValue:''
			}
		},
		methods:{
			openDialogWeb: function () {
				// this.fn_getItems();
				this.searchValue = '';
				let fieldData = this.getFieldData();
				fieldData.sectionName ? this.selectedSection = fieldData.sectionName : this.selectedSection = null;
				this.sectionListDialog = true;
			},
			closeDialogWeb: function () {
				this.sectionListDialog = false;
			},
			fn_openSectionForm: function () {
				this.searchValue = '';
				this.openSectionForm();
			}
		},
		computed:{
			filteredItems: function () {
		        let searchText = this.searchValue.toLowerCase();

		        // return this.$parent.sectionItemList.filter(item => {
		        //   let fieldName = item.sectionName.toLowerCase();
		        //   return fieldName.match(searchText);
		        // })
		         return this.$parent.Form.fieldItems.filter(item => {
		          let fieldName = item.section.sectionName.toLowerCase();
		          return fieldName.match(searchText);
		        })
		      }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/fields/dialog_section_list.vue